import classNames from "classnames";
import Icon from "./icon";

type DurationProps = {
  duration?: number;
  centered?: boolean;
};

export const formatDuration = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  const formattedSeconds =
    remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

  return `${minutes}:${formattedSeconds}`;
};

export const formatAccessibleDuration = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const minuteText = minutes === 1 ? "1 minut" : `${minutes} minuter`;
  const secondText =
    remainingSeconds === 1 ? "1 sekund" : `${remainingSeconds} sekunder`;

  if (minutes > 0 && remainingSeconds > 0) {
    return `${minuteText}, ${secondText}`;
  } else if (minutes > 0) {
    return minuteText;
  } else {
    return secondText;
  }
};

const Duration = (props: DurationProps) => {
  return (
    <div
      className={classNames(
        "flex overflow-hidden ",
        props.centered
          ? "top-0 left-0 flex items-center justify-center"
          : "absolute top-2 left-2 ",
      )}
    >
      <div className="bg-static-black lg:hover:bg-purple-500 w-[32px] h-[32px] flex items-center justify-center">
        <Icon.Play className="text-static-white" aria-label="Video" />
      </div>
      {props.duration && (
        <>
          <div
            className="text-static-white text-sm font-bold h-[32px] bg-static-black/80 flex items-center px-2"
            aria-hidden="true"
          >
            {formatDuration(props.duration)}
          </div>
          <span className="sr-only text-static-white">
            {formatAccessibleDuration(props.duration)}
          </span>
        </>
      )}
    </div>
  );
};

export default Duration;
